// extracted by mini-css-extract-plugin
var _1 = "A0OYEQAT";
var _2 = "A0OYEQAT";
export { _1 as "search-type", _2 as "searchType" }
